var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.88889 7H4.33333V8.4H2.88889V7ZM13 2.8V12.6C13 12.9713 12.8478 13.3274 12.5769 13.5899C12.306 13.8525 11.9386 14 11.5556 14H1.44444C0.642778 14 0 13.37 0 12.6V2.8C0 2.4287 0.152182 2.0726 0.423068 1.81005C0.693954 1.5475 1.06135 1.4 1.44444 1.4H2.16667V0H3.61111V1.4H9.38889V0H10.8333V1.4H11.5556C11.9386 1.4 12.306 1.5475 12.5769 1.81005C12.8478 2.0726 13 2.4287 13 2.8ZM1.44444 4.2H11.5556V2.8H1.44444V4.2ZM11.5556 12.6V5.6H1.44444V12.6H11.5556ZM8.66667 8.4V7H10.1111V8.4H8.66667ZM5.77778 8.4V7H7.22222V8.4H5.77778ZM2.88889 9.8H4.33333V11.2H2.88889V9.8ZM8.66667 11.2V9.8H10.1111V11.2H8.66667ZM5.77778 11.2V9.8H7.22222V11.2H5.77778Z",
    fill: "#6B7482"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.36fcdeb5.svg";
export { ForwardRef as ReactComponent };